//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'GoogleRecaptchaText',
  props: {
    noInvert: {
      type: Boolean,
      default: false,
    },
  },
};
